import { HealthReport } from "@cosmosai/shared";
import { useQuery } from "@tanstack/react-query";
import { useAppFetch } from "../../api/client";

export function useHealth() {
  const appFetch = useAppFetch();
  return useQuery({
    queryKey: ["health"],
    queryFn: async (): Promise<HealthReport> =>
      HealthReport.parse(await appFetch<unknown>("/health")),
    refetchInterval: 15_000,
  });
}
